import Dosa from "../images/dosa.jpg";
import Chola from "../images/chhola.jpg";
import Idli from "../images/idli.jpg";
import MasalaDosa from "../images/masala.jpg";
import Paneer from "../images/paneer.jpg";
import Gujrati from "../images/gujrati.jpeg";

export const MenuList = [
  {
    name: "Dosa",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Placeat, ab!",
    image: Dosa,
    price: 200,
  },
  {
    name: "Chola",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Placeat, ab!",
    image: Chola,
    price: 250,
  },
  {
    name: "Idli Sambhar",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Placeat, ab!",
    image: Idli,
    price: 300,
  },
  {
    name: "Masala Dosa",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Placeat, ab!",
    image: MasalaDosa,
    price: 100,
  },
  {
    name: "Paneer",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Placeat, ab!",
    image: Paneer,
    price: 400,
  },
  {
    name: "Gujrati",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Placeat, ab!",
    image: Gujrati,
    price: 500,
  },
];
